'use client';

import { PrudsysCategoryToBrandsRecoSlider } from '@packages/recommendations/src/components/BrandsRecoSliders/PrudsysCategoryToBrandsRecoSlider/PrudsysCategoryToBrandsRecoSlider.client';
import { PrudsysCategoryToCategoriesRecoSlider } from '@packages/recommendations/src/components/CategoriesRecoSliders/PrudsysCategoryToCategoriesRecoSlider/PrudsysCategoryToCategoriesRecoSlider.client';
import { CriteoViewHomeProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/CriteoViewHomeProductsRecoSlider/CriteoViewHomeProductsRecoSlider.client';
import { LastSeenProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/LastSeenProductsRecoSlider/LastSeenProductsRecoSlider.client';
import { PrudsysCategoryToProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/PrudsysCategoryToProductsRecoSlider/PrudsysCategoryToProductsRecoSlider.client';
import { PrudsysHomepageProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/PrudsysHomepageProductsRecoSlider/PrudsysHomepageProductsRecoSlider.client';
import type { PageTemplate } from '@packages/recommendations/src/types';
import type { RecommendationType } from './types';

const Reco = ({
  data,
  pageTemplate,
  elementIndex = 0,
}: {
  data: RecommendationType;
  elementIndex?: number;
  pageTemplate: PageTemplate;
}) => {
  const {
    field_reco_service: recoServiceType,
    field_shop_id: categoryId = '',
    field_auto_headline_disabled: disableAutoHeadline,
    behavior_paragraph_background_color: backgroundColor,
  } = data;

  switch (recoServiceType) {
    case 'prudsysCategoryToProducts':
    case 'prudsysCategoryToProductsPapi':
      return (
        <PrudsysCategoryToProductsRecoSlider
          categoryId={categoryId}
          pageTemplate={pageTemplate}
          elementIndex={elementIndex}
          title=""
          preferTitle={disableAutoHeadline}
          fetchOnThreshold
          backgroundColor={backgroundColor}
        />
      );

    case 'prudsysCategoryToCategories':
      return (
        <PrudsysCategoryToCategoriesRecoSlider
          categoryId={categoryId}
          sourceCategoryId="1"
          pageTemplate={pageTemplate}
          elementIndex={elementIndex}
          title=""
          preferTitle={disableAutoHeadline}
          fetchOnThreshold
          backgroundColor={backgroundColor}
        />
      );

    case 'prudsysCategoryToBrands':
    case 'prudsysCategoryToBrandsPapi':
      return (
        <PrudsysCategoryToBrandsRecoSlider
          categoryId={categoryId}
          sourceCategoryId="1"
          pageTemplate={pageTemplate}
          elementIndex={elementIndex}
          title=""
          fetchOnThreshold
          backgroundColor={backgroundColor}
        />
      );

    case 'prudsysUserToProductsPapi':
    case 'prudsysHomePage': // in drupal: UserToProductsPrudsys
      return (
        <PrudsysHomepageProductsRecoSlider
          pageTemplate={pageTemplate}
          elementIndex={elementIndex}
          title=""
          preferTitle={disableAutoHeadline}
          fetchOnThreshold
          backgroundColor={backgroundColor}
        />
      );
    case 'lastSeen':
      return (
        <LastSeenProductsRecoSlider
          pageTemplate={pageTemplate}
          elementIndex={elementIndex}
          fetchOnThreshold
          title=""
          backgroundColor={backgroundColor}
        />
      );
    case 'criteo':
      return (
        <CriteoViewHomeProductsRecoSlider
          elementIndex={elementIndex}
          pageTemplate={pageTemplate}
          title=""
          fetchOnThreshold
          backgroundColor={backgroundColor}
        />
      );
    default:
      return <span data-testid="cms-reco-no-reco-type-found" />;
  }
};

export const CmsRecommendation = ({
  data,
  recoIndex = 0,
  pageTemplate = 'homepage',
}: {
  data: RecommendationType;
  recoIndex?: number;
  pageTemplate?: PageTemplate;
}) => {
  const { field_margin: margin } = data;

  return (
    // use margin from cms. if no marging has been given by cms, set a margin-bottom of 8.
    <div className={[margin ? null : 'mb-8'].join()} style={{ margin }}>
      <Reco data={data} pageTemplate={pageTemplate} elementIndex={recoIndex} />
    </div>
  );
};
